import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import theme from './theme'

import { CookiesProvider } from 'react-cookie'
import { CsrfProvider } from './utils/context/CsrfContext'
import { AuthProvider } from './utils/context/AuthContext'
import { ModalProvider } from './utils/context/ModalContext'
import { configureAmplify } from './auth/amplify-config'
import HarborCsThemeProvider from './utils/context/HarborCsThemeProvider'
import BrushStrokeProvider from './utils/context/BrushStrokeProvider'
import { NavigationHistoryProvider } from './utils/context/NavigationHistoryContext'
import SearchContext from './components/Search/SearchContext'
import ErrorBoundary from './components/ErrorBoundary'
import AnalyticsIdentityBridge from './utils/analytics/AnalyticsIdentityBridge'

configureAmplify()

const WrapRootElement = ({ element }) => (
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CookiesProvider>
        <CsrfProvider>
          <AuthProvider>
            <AnalyticsIdentityBridge />
            <ModalProvider>
              <HarborCsThemeProvider>
                <BrushStrokeProvider>
                  <NavigationHistoryProvider>
                    <SearchContext.DiscoveryEngineProvider>
                      {element}
                    </SearchContext.DiscoveryEngineProvider>
                  </NavigationHistoryProvider>
                </BrushStrokeProvider>
              </HarborCsThemeProvider>
            </ModalProvider>
          </AuthProvider>
        </CsrfProvider>
      </CookiesProvider>
    </ThemeProvider>
  </ErrorBoundary>
)

WrapRootElement.propTypes = {
  element: PropTypes.node,
}

export default WrapRootElement